/** WorktimeImportKnownUsecase enumeration */
export enum WorktimeImportKnownUsecase {
  Unknown = "unknown",
  Palkkaus = "palkkaus",
  Mepco = "mepco",
  Tyovuorovelho = "tyovuorovelho",
  MaraPlan = "maraPlan",
  Other = "other",
}